jQuery(() => {
  /*
   * Mobile Menu
  */
  function clearPopUp() {
    jQuery('.menu-wrapper >').removeClass('active');
    jQuery('#overlay').removeClass('open');
    jQuery('body').removeClass('menu-open');
  }
  jQuery('.menu-wrapper >').click(() => {
    jQuery(this).toggleClass('active');
    jQuery('#overlay').toggleClass('open');
    jQuery('body').toggleClass('menu-open');
  });
  jQuery(document).keyup((e) => {
    if (e.keyCode === 27) { // escape key maps to keycode `27`
      if (jQuery('body').hasClass('menu-open')) {
        clearPopUp();
      }
    }
  });

  /*
   * Swipebox
  */
  jQuery('.swipebox').swipebox({
    useCSS: true,
    useSVG: false,
    initialIndexOnArray: 0,
    hideCloseButtonOnMobile: false,
    hideBarsDelay: false,
  });

  ['resize', 'load'].forEach((event) => {
    window.addEventListener(event, () => {
      document.querySelectorAll('.venues-col-set, .alphabetical-list').forEach((parent) => {
        let lastElement;
        let colCount = 1;
        let maxColCount = 0;
        let topRowFound = false;
        parent.querySelectorAll('.venue:not(.hidden), ul li:not(.hidden)').forEach((item) => {
          item.classList.remove('top-row');
          item.classList.remove('last-in-row');

          if (typeof lastElement !== 'undefined' && (item.offsetTop !== lastElement.offsetTop)) {
            lastElement.classList.add('last-in-row');
            colCount = 1;
            topRowFound = true;
          }

          if (!topRowFound) {
            item.classList.add('top-row');
          }

          if (colCount > maxColCount) {
            maxColCount = colCount;
          }

          colCount += 1;
          lastElement = item;
        });


        for (let i = 1; i <= 6; i += 1) {
          parent.classList.remove(`cols-${i}`);
        }
        parent.classList.add(`cols-${maxColCount}`);

        if (typeof lastElement !== 'undefined') {
          lastElement.classList.add('last-in-row');
        }
      });
    });
  });

  /*
  * Mobile menu overlap effetcs
  */
  jQuery('#overlay').scroll(() => {
    if (jQuery('header > .overlay.open > .container').overlaps('header > .wrapper-header > .home-url').length) {
      jQuery('header > .wrapper-header > .home-url > a').addClass('overlaps');
    } else {
      jQuery('header > .wrapper-header > .home-url > a').removeClass('overlaps');
    }
  });
});
